<template>
  <div id="comments">
    <nav-bar/>
    <v-main class="third-bg">
      <div class="container-fluid container-md py-10">
        <div class="row">
          <div class="col-12 text-center">
            <h1>
              <span class="font-19 border-bottom-gold px-5">نظرات و شکایات</span>
            </h1>
          </div>
          <div v-if="isLoggedIn" class="col-12">
            <div class="mt-5 font-16">نوع نظر</div>
            <v-select
                class="mt-2"
                :items="commentType"
                item-value="id"
                item-text="text"
                v-model="suggestionType"
                :menu-props="{offsetY: true}"
                solo
                flat
            ></v-select>
            <div class="mt-5 font-16">موضوع</div>
            <div>
              <v-text-field
                  v-model="subject"
                  class="mt-2"
                  solo
                  hide-details
                  dense
                  single-line
                  flat
              ></v-text-field>
            </div>
            <div class="mt-5 font-16">متن</div>
            <div>
              <v-textarea
                  v-model="textModel"
                  class="mt-2"
                  solo
                  name="input-7-4"
                  flat
              ></v-textarea>
            </div>
            <v-btn
                block
                color="primary"
                elevation="0"
                @click="sendSuggestion">
              انجام
            </v-btn>
          </div>
          <div v-else class="col-10 mx-auto">
            <v-alert color="primary" outlined class="text-center">
              <div class="font-18">برای ثبت نظرات و شکایات خود ابتدا باید وارد سایت شوید.</div>
              <div class="mt-3">
                <v-btn color="primary" elevation="0" @click="registerDialog = true">
                  ورود
                </v-btn>
              </div>
            </v-alert>
          </div>
        </div>
      </div>
    </v-main>
    <footer-component/>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="530">
      <v-card class="text-center">
        <v-card-title class="justify-space-between secondary-bg">
          <v-btn
              color="primary"
              icon
              @click="showResultDialog = false">
            <i class="fas fa-times ml-1"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="registerDialog"
        hide-overlay
        width="500">
      <v-card class="third-bg">
        <v-card-title class=" lighten-2 secondary-bg">
          <div class="row justify-content-between">
            <div class="col-auto  font-16 white--text">ورود / ثبت نام</div>
            <div class="col-auto">
              <v-btn
                  color="primary"
                  icon
                  small
                  @click="registerDialog = false"
              >
                <i class="fas fa-times font-16 ml-1"></i>
              </v-btn>
            </div>
          </div>
        </v-card-title>
        <v-card-text class=" py-4">
          <v-form ref="form">
            <div class="my-4 text-right">موبایل</div>
            <v-text-field
                v-model="mobile"
                :rules="phoneNumberRules"
                class="mb-1"
                dense
                flat
                placeholder="موبایل"
                solo
                type="number">
            </v-text-field>
            <div class="my-3 text-center">
              <v-btn :disabled=" mobile === null || mobile.length != 11"
                     class="px-10"
                     color="primary"
                     elevation="0"
                     rounded
                     @click="getVerifyCode">
                <span class="white--text"> درخواست کد</span>
              </v-btn>
            </div>
            <div class="my-4 text-right">کد تایید موبایل</div>
            <v-text-field
                v-model="password"
                :rules="[v => !!v || 'کد تایید  اجباری است']"
                class="mb-1"
                dense
                flat
                placeholder="رمزعبور"
                solo>
            </v-text-field>
            <div class="my-3 text-center">
              <v-btn :disabled="password === null || password.length ===0" class="px-16" color="primary" elevation="0"
                     rounded
                     @click="register">
                <span class="white--text">ثبت نام/ورود</span>
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
        <!--            <v-card-actions class='row text-right'>
                      <div class="col-12 px-md-8">
                        رمزعبور خود را فراموش کرده اید؟
                        <span class="pointer text-primary" @click="forgetPasswordDialog =true">
                          بازیابی رمزعبور
                        </span>
                      </div>
                    </v-card-actions>-->
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";

export default {
  name: "CommentsAndComplaints",
  components: {FooterComponent, NavBar},
  metaInfo () {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  data: () => ({
    dialogResult: null,
    showLoaderDialog: false,
    showResultDialog: false,
    textModel: null,
    suggestionType: null,
    commentType: [{id: '1', text: 'انتقاد'}, {id: '2', text: 'پیشنهاد'}],
    subject: null,
    setSuggestion: null,
    isLoggedIn: false,
    registerDialog: false,
    mobile: null,
    phoneNumberRules: [
      v => !!v || 'شماره موبایل اجباری است',
      value => (value && value[0] === "0") || 'اولین رقم موبایل با عدد صفر شروع می شود ',
      value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
    ],
    password: null,
  }),
  mounted() {
    this.silentLogin()
    this.$convertFarsiNumber()
  },
  methods: {
    silentLogin() {
      let userData = this.$getUserData()
      if (userData.mobile !== '' && userData.activeCode !== '' && userData.mobile !== undefined && userData.activeCode !== null) {
        let resStatus = null
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("PhoneNumber", userData.mobile);
        urlencoded.append("VerifyCode", userData.activeCode);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Client/LoginRegister", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              this.showLoaderDialog = false
              if (resStatus === 200) {
                let json = JSON.parse(result)
                let token = 'Bearer ' + json.JwtToken
                this.$setUserData(userData.mobile, userData.activeCode, token, json.Role);
                this.isLoggedIn = true;
                if (json.Role === 1 || json.Role === 2 || json.Role === 3) {
                  this.$router.replace({path: '/Dashboard'})
                }
              } else {
                this.isLoggedIn = false
              }
            })
            .catch(error => console.log('error', error));
      } else {
        this.isLoggedIn = false
      }
    },
    sendSuggestion() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("Description", this.textModel);
      urlencoded.append("Subject", this.subject);
      urlencoded.append("TypeSuggestionCritic", this.suggestionType);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/SuggestionCritic", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.showResultDialog = true
            this.dialogResult = result
          })
          .catch(error => console.log('error', error));
    },
    getVerifyCode() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("PhoneNumber", this.mobile);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/RecoveryOrRequestVerfiyMobile", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.showResultDialog = true
            this.dialogResult = result
          })
          .catch(error => console.log('error', error));
    },
    register() {
      let resStatus = null
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("PhoneNumber", this.mobile);
      urlencoded.append("VerifyCode", this.password);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/LoginRegister", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus !== 200) {
              this.dialogResult = result
              this.showResultDialog = true
            } else {
              let json = JSON.parse(result)
              this.token = 'Bearer ' + json.JwtToken
              this.$setUserData(this.mobile, this.password, this.token, json.Role);
              this.registerDialog = false
              this.isLoggedIn = true
              if (json.Role === 1 || json.Role === 2 || json.Role === 3) {
                this.$router.replace({path: '/Dashboard'})
              } else {
                if (this.$route.path !== "/HomePage") {
                  this.$router.push({path: 'HomePage'})
                }
              }

            }

          })
          .catch(error => console.log('error', error));
    }

  }
}
</script>

<style scoped>

</style>